<template lang="pug"> 
  v-row(no-gutters justify="center")
    v-col(cols=12 md=6).px-3.pt-3
      v-form(
        ref='form'
        @submit.prevent
      )
        v-row 
          v-col(cols=12)
            n-text-field-username(
              v-model='form.username'
              disabled
              hideDetails="auto"
              :label="$t('label.username')"
              :placeholder="$t('placeholder.username')"
            )
          v-col(cols=12)
            n-text-field-specific(
              v-model='form.first_name'
              hideDetails="auto"
              :rules='firstNameRules'
              :disabled='status||editstat'
              :label="$t('label.name')"
              :placeholder="$t('placeholder.name')"
            )
          v-col(cols=12)
            n-text-field-specific(
              v-model='form.last_name'
              hideDetails="auto"
              :rules='lastNameRules'
              :disabled='status||editstat'
              :label="$t('label.surname')"
              :placeholder="$t('placeholder.surname')"
            )
          v-col(cols=12)
            v-menu(
              ref='menu'
              :close-on-content-click='false'
              transition='scale-transition'
              offset-y
              hideDetails="auto"
              min-width='290px'
            )
              template(v-slot:activator='{ on }')
                v-text-field(
                  v-on='on'
                  v-model='form.birthday'
                  dense
                  required
                  outlined
                  readonly
                  persistent-hint
                  :rules='dateRules'
                  :disabled='status||editstat||has_birthdate'
                  hideDetails="auto"
                  :label="$t('label.birthdate')"
                  :placeholder="$t('placeholder.birthdate')"
                )
              v-date-picker(
                ref='picker'
                v-model='form.birthday'
                locale='th'
                :max='maxDate'
              )
          v-col(cols=12)
            n-number-field-specific(
              v-model='form.phone'
              disabled
              required
              hideDetails="auto"
              :label="$t('label.phone-number')"
              :placeholder="$t('placeholder.phone-number')"
            ) 
          v-col(cols=12)
            v-text-field(
              v-model='form.email'
              dense
              outlined
              hideDetails="auto"
              :rules="emailRules"
              :disabled='editstat'
              :label="$t('label.email')"
              :placeholder="$t('placeholder.email')"
            )
          v-col(cols=12)
            n-text-field-noemoji(
              v-model='form.line_id'
              required
              hideDetails="auto"
              :rules="lineRules" 
              :disabled='editstat'
              :label="$t('label.line')"
              :placeholder="$t('placeholder.line')"
            )
          v-col(
            v-if="false"
            cols=12
          )
            n-btn-submit(
              v-if='editstat' 
              @click='edit'
            ) {{ $t('button.edit') }}
            n-btn-submit(
              v-else
              :loading='submitstatus'
              @click='submit'
            ) {{ $t('button.save') }}

</template>
<script>
import { getIsoDateFormat } from '@/plugins/time'
import { users as apiMe } from '@/apis'  
import Validation from '@/mixins/Validations'
export default { 
  mixins: [Validation], 
  data: () => ({
    form:{
      username: null,
      first_name:null,
      last_name:null,
      birthday:null,
      phone:null,
      email:null,
      line_id:null,
    },
    editstat:true,
    status : false, 
    submitstatus:false,
    maxDate:'',
    has_birthdate: false,
  }),
  computed: {
    userProfile () {
      return this.$store.getters['userProfile/GETTERS_ME']
    },
  },
  watch : { 
    userProfile () {
      if(this.userProfile){
        this.setData() 
      }
    }
  },
  async mounted () {
    this.maxDate = getIsoDateFormat()  
    this.setData()
  },

  methods : { 
    setData () {
      //initial map profile
      const { 
        username, 
        first_name, 
        last_name,
        birthdate,
        phone,
        email,
        line_id  
      } = this.userProfile
      this.form.username = username
      this.form.first_name = first_name
      this.form.last_name = last_name
      this.form.birthday = birthdate
      this.form.phone = phone
      this.form.email = email
      this.form.line_id = line_id 

      this.has_birthdate = !!birthdate
    },
    async submit () {   
      this.$ga.event('Submit', 'SubmitEditProfile', 'SettingPage','' )    
      if(this.$refs.form.validate()) {  
        const { first_name, last_name, line_id, email, birthday } = this.form
        const form = {
          first_name ,
          last_name,
          birthdate: birthday
        }

        if (line_id) {
          form.line_id = line_id
        }

        if (email) {
          form.email = email
        }

        this.submitstatus = true 
        const [err, data, message] = await apiMe.updateProfile(form)
        this.submitstatus = false
        this.editstat = !this.editstat 

        if(err){
          this.$alert('',err,'warning')
          return
        }
        this.$alert('',message,'success')
        this.$store.commit('userProfile/MUTATION_ME', data) 
        this.$refs.form.resetValidation()
        this.setData()
      }       
    }, 
    edit (){
      this.$ga.event('Button', 'EditProfile', 'SettingPage','' )
      this.editstat = !this.editstat
    },
  }
}
</script>